import React from 'react';

// Support page for the App Store listing's support URL.
const Support = () => (
  <div className="min-h-screen bg-gray-900 text-gray-200">
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-white mb-8">JukeHive Support</h1>

      <div className="space-y-8 text-sm leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Quick answers</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong className="text-white">Guests don't need an account or the app</strong> —
              scanning the party's QR code opens everything in the browser. Enter a name
              (2+ characters) and you're in.
            </li>
            <li>
              <strong className="text-white">Location won't cooperate?</strong> Every party has
              a 4-digit PIN on the host's invite screen — joining with the party ID + PIN
              works from anywhere.
            </li>
            <li>
              <strong className="text-white">Hosting from iPhone</strong> plays music through
              your own Apple Music subscription and keeps playing with the app in the
              background or the phone locked.
            </li>
            <li>
              <strong className="text-white">Something inappropriate?</strong> Long-press any
              message to report it or mute the sender. Hosts can block guests from the
              People tab.
            </li>
            <li>
              <strong className="text-white">Delete your account</strong> in the app under
              Profile → Delete Account — it erases everything, permanently.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Contact us</h2>
          <p>
            Email <a className="text-purple-400" href="mailto:eugenew.evans@gmail.com">eugenew.evans@gmail.com</a> —
            we read everything and reply as fast as we can.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Privacy</h2>
          <p>
            Our privacy policy lives at{' '}
            <a className="text-purple-400" href="/privacy">jukehive privacy policy</a>.
          </p>
        </section>
      </div>
    </div>
  </div>
);

export default Support;
